module.exports = __webpack_public_path__ + "static/img/1.e929cd5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/3/1.png
// module id = rrR2
// module chunks = 0